import { Breadcrumbs, ItServiceIntro, OtherServices, PricingPlan } from "@/components/features/itServicePackage";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function ItServicePackage() {
    return(
        <div>
            <SEO
                title="Managed IT Proactive Support Services - SAN micron"
                description="Unlock seamless business operations with our Managed IT Proactive Support. We monitor, manage, and optimize your IT infrastructure to prevent issues, enhance security, and ensure maximum uptime for your business."
            />
           <Breadcrumbs />
           <ItServiceIntro />
           <PricingPlan />
           <OtherServices />
           <CallToAction 
                title="We offer Proactive IT management"
            />
            <div className="abstract-bg">
                 {/* <FAQ /> */}
            </div>
            <Footer />
        </div>
    );
}